export const categories = [
  {
    name: 'Debt Relief',
    icon: '/resources/home/debt_relief.svg',
    excerpt: '',
  },
  {
    name: 'Credit Card Debt',
    icon: '/resources/home/credit_card_debt.svg',
    excerpt: '',
  },
  { name: 'Loans', icon: '/resources/home/loans.svg' },
  {
    name: 'Veteran Debt',
    icon: '/resources/home/veteran_debt.svg',
    excerpt: '',
  },
  {
    name: 'Medical Debt',
    icon: '/resources/home/medical_debt.svg',
    excerpt: '',
  },
  {
    name: 'Money Management',
    icon: '/resources/home/money_management.svg',
    excerpt: '',
  },

  {
    name: 'Types of Debt',
    icon: '/resources/home/types_of_debt.svg',
    excerpt: '',
  },
  {
    name: 'Bad Credit',
    icon: '/resources/home/bad_credit.svg',
    excerpt: '',
  },
  {
    name: 'Debt Settlement',
    icon: '/resources/home/debt_settlement.svg',
    excerpt: '',
  },
  {
    name: 'Debt Consolidation',
    icon: '/resources/home/debt_consolidation.svg',
    excerpt: '',
  },
  {
    name: 'Debt Management',
    icon: '/resources/home/debt_management.svg',
    excerpt: '',
  },
  {
    name: 'Credit Repair',
    icon: '/resources/home/credit_repair.svg',
    excerpt: '',
  },
  {
    name: 'Mortgage Debt',
    icon: '/resources/home/mortgage_debt.svg',
    excerpt: '',
  },
  {
    name: 'Divorce Debt',
    icon: '/resources/home/divorce_debt.svg',
    excerpt: '',
  },
  {
    name: 'Tax Debt',
    icon: '/resources/home/tax_debt.svg',
    excerpt: '',
  },
  {
    name: 'Gambling Debt',
    icon: '/resources/home/gambling_debt.svg',
    excerpt: '',
  },
  {
    name: 'Financial Hardship',
    icon: '/resources/home/financial_hardship.svg',
  },
  {
    name: 'Credit Counseling',
    icon: '/resources/home/credit_counseling.svg',
  },
  { name: 'Financial Stress', icon: '/resources/home/financial_stress.svg' },
  { name: 'Bankruptcy', icon: '/resources/home/bankruptcy.svg' },
  { name: 'Business Debt', icon: '/resources/home/business.svg' },
  { name: 'Areas We Serve', icon: '/resources/home/areas_we_serve.svg' },
  { name: 'Senior Debt', icon: '/resources/home/Senior.svg' },
  { name: 'Car Debt', icon: '/resources/home/car.svg' },
]

export const articlesByCategory = {
  'Debt Relief': [
    {
      title: 'Everything You Need To Know About Debt Relief',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/5e178f6017178f6a9a19c9b35f407d4c.webp',
      excerpt:
        'Debt relief refers to strategies that are used to make debt easier to manage.',
      link: '/debt-relief',
    },
    {
      title: 'Credit Card Debt Relief: How You Can Get Out of Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/2ef43d42d3b8d9bf56b71937fafe123f.webp',
      link: '/debt-relief/credit-card',
    },
    {
      title: 'Medical Debt Relief: How to Pay It Off',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/0fb1b774671f54cd435c7dbd4edb1b62.webp',
      link: '/debt-relief/medical',
    },
    {
      title: 'Tax Debt Relief: How to Get Out of Your IRS Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/ff10e2971bae526aec1390f757146b03.webp',
      link: '/debt-relief/tax',
    },
  ],
  'Credit Card Debt': [
    {
      title: 'How to Regain Control of Credit Card Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/e3e77aa7ac4bff47f99c803600f4c37a.webp',
      excerpt:
        'Owning a credit card is a privilege, but it requires careful use. Don’t let credit card debt choke your financial future. The right repayment strategies can help you nip the problem in the bud.',
      link: '/credit-card-debt',
    },
    {
      title: 'Everything You Need to Know About Credit Card Consolidation',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/94e88f8efc0a9371a517752d246115d9.webp',
      link: '/credit-card-debt/consolidation',
    },
    {
      title: 'How To Pay Off $10,000 in Credit Card Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/de63640206c6751c42cbcda99b74b554.webp',
      link: '/credit-card-debt/how-to-pay-off-10k-in-credit-card-debt',
    },
    {
      title: 'The Truth About Credit Card Debt Forgiveness',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/6209a4d27adb27057949d26a044e9d0f.webp',
      link: '/credit-card-debt/forgiveness',
    },
  ],
  'Veteran Debt': [
    {
      title: 'Veteran Debt: How To Pay Off Your VA Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/e36028f4c83147bce8d9add202269721.webp',
      excerpt:
        'if you are dealing with a lot of debt as a veteran, explore options like VA debt forgiveness, offer in compromise, and debt consolidation.',
      link: '/veteran-debt',
    },
    {
      title:
        'Navy Federal Credit Union: Financial Services for Military Members',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/2086a38a0df1961a0cfd993d991ae1c4.webp',
      link: '/veteran-debt/navy-federal',
    },
    {
      title: 'Military and Veteran Debt Relief Programs: What Are the Options?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/6f8b7604a6720713f472085d8e2340de.webp',
      link: '/veteran-debt/relief-programs',
    },
    {
      title: 'Loans for Veterans: A Complete Guide',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/675793dc8ca8caa8dc08023ca29a0877.webp',
      link: '/veteran-debt/loans',
    },
  ],
  'Medical Debt': [
    {
      title: 'How To Pay Off Your Medical Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/e9906ad13b63ee36e0bdd40b23365f20.webp',
      excerpt:
        'An illness can leave you with substantial medical debt. If you don’t have any savings to depend on, there are many other options available to ease the burden.',
      link: '/medical-debt',
    },
    {
      title: 'What Is Medical Payments Coverage and What Does It Cover',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/3f95cae106ef8aecf48639fece059bb3.webp',
      link: '/medical-debt/payment',
    },
    {
      title: 'How Does Medical Debt Affect Your Credit Score',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/c79f1caef4c76ed843fe3a37e36ea0af.webp',
      link: '/medical-debt/credit-score-impact',
    },
    {
      title:
        'Can You Go To Jail For Not Paying Medical Bills: What You Need To Know',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/d4d520650c6c92994e995298c9b6e0b3.webp',
      link: '/medical-debt/can-you-go-to-jail-for-not-paying-medical-bills',
    },
  ],
  'Money Management': [
    {
      title: '7 Money Management Tips For Financial Security',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/65435662dd001c75848e41e6ea568e21.webp',
      excerpt:
        'Without money management, you’ll always feel like you’re one step away from a financial disaster. Money management can bring you a sense of security and ease your stress.',
      link: '/money-management',
    },
    {
      title: 'The Helpful Guide to 401(k) Plans',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/8402be90307a49266fe206839195b3e7.webp',
      link: '/money-management/401k',
    },
    {
      title: 'Understanding a Maturity Date: Definition and Key Payment Info',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/a411d9f35b1b979ebcfc8843027f0b79.webp',
      link: '/money-management/maturity-date',
    },
    {
      title: 'Understanding Purchase APR: Everything You Need to Know',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/0c6e47b744a18dc3a16916c1dc634834.webp',
      link: '/money-management/purchase-apr',
    },
  ],
  'Types of Debt': [
    {
      title: 'What Are The Main Types of Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/32f15590e99c86cb7efeedbe9536349f.webp',
      excerpt:
        'The best approach to deal with debt is to stay prepared and get aware of the different types of debt and their implications. Keep your eyes focused on the text, and we’ll guide you through all the ins and outs of the different types of debt and how they work.',
      link: '/types-of-debt',
    },
    {
      title: 'What Is Unsecured Debt?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/f5180b6194db8cdbf4c10d9165b523d9.webp',
      link: '/types-of-debt/unsecured',
    },
    {
      title: 'Consumer Debt: Types, Advantages, and Disadvantages',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/2535e243c0e8f26d782fa69a80bd1063.webp',
      link: '/types-of-debt/consumer',
    },
    {
      title: 'What Is Secured Debt?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/4e5da9b57c3a955e3a8194895f475b3b.webp',
      link: '/types-of-debt/secured',
    },
  ],
  'Bad Credit': [
    {
      title: 'What Is Bad Credit and What To Do About It',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/5d4aec1422d57839cdf67b910f7f31fa.webp',
      excerpt:
        'Repaying debt can be burdensome at times due to unforeseen or inevitable circumstances. You must make regular debt repayments to avoid your credit score taking a hit. Debt is an essential tool for creditors to assess an individual’s creditworthiness, but you must aim to maintain it in good standing. Let’s understand what bad credit is, what it can mean to you as a debt borrower, and what to do if you already have a poor credit score.',
      link: '/bad-credit',
    },
    {
      title: 'How to Rent an Apartment with a Poor Credit History',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/40c611664b7f5e0e8d55dceb81876d5c.webp',
      link: '/bad-credit/renting-an-apartment',
    },
    {
      title: 'Accessing Consolidation Loans With Bad Credit',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/82f66654a590aa00169e05e8e2b4ac44.webp',
      link: '/bad-credit/consolidation-loans-with-bad-credit',
    },
    {
      title: '9 Tips To Get out of Debt When You Have Bad Credit',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/639a8e12cc519581df7e4d2a3af226c1.webp',
      link: '/bad-credit/debt-relief',
    },
  ],
  'Debt Settlement': [
    {
      title: 'How Debt Settlement Can Get You Out of Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/0f28902b5342b994704f6efa88bbd854.webp',
      excerpt:
        'Like millions of Americans, if you are feeling overwhelmed with debt, you may want to consider debt settlement. You may be able to clear your accounts and save up to 50% on your original debts when you choose this option.',
      link: '/debt-settlement',
    },
    {
      title: 'Debt Resolution vs. Debt Settlement: Which One Is Best for You?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/b9cb1866ff7567af32c17e043db00b9a.webp',
      link: '/debt-settlement/debt-resolution-vs-debt-settlement',
    },
    {
      title: 'Debt Settlement Negotiation on Your Own: A Step-By-Step Guide',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/7a585b1d1402f8089686b77c1d6dadfc.webp',
      link: '/debt-settlement/how-to-negotiate-on-your-own',
    },
    {
      title: 'How a Debt Settlement Attorney Can Help You',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/0565256e9be5ff42e43185b9ae951cba.webp',
      link: '/debt-settlement/attorney',
    },
  ],
  'Debt Consolidation': [
    {
      title: 'How Debt Consolidation Works',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/44772782cabb101a15dfa2f986e57bf6.webp',
      excerpt:
        'Keeping track of balances and payments can be difficult between multiple credit cards, auto loans, and student loans. Debt consolidation can help streamline your repayments and save money on interest charges.',
      link: '/debt-consolidation',
    },
    {
      title: 'Debt Consolidation Loan',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/a2795d21138c0b40d9f7cd0e926323b4.webp',
      link: '/debt-consolidation/loan',
    },
    {
      title: 'How the SoFi Debt Consolidation Program Works',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/77864ca5c1b8b29fb1eb014f4598a89e.webp',
      link: '/debt-consolidation/sofi',
    },
  ],
  'Debt Management': [
    {
      title: 'What You Need To Know About Debt Management',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/9af61a78b7a1816871fc5252b8b8bb82.jpeg',
      excerpt:
        'Debt is an effective method to support your income and financial needs. However, taking on more debt than you can handle becomes problematic in the future.',
      link: '/debt-management',
    },
    {
      title: 'Pros and Cons of Debt Management Programs',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/b85eee786eea0ecb4fb5b28b2a18f2d0.webp',
      link: '/debt-management/programs',
    },
    {
      title: 'Debt and Marriage: Am I Responsible for My Spouse’s Debt?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/2f296c592d73c441a04d6aec0bdff251.webp',
      link: '/debt-management/am-i-responsible-for-my-spouses-debt',
    },
    {
      title: 'Bankruptcy or Debt Relief: Picking the Right Option',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/4c9efda705d5a791434a6a678550980b.webp',
      link: '/debt-management/bankruptcy-vs-debt-relief',
    },
  ],
  'Credit Repair': [
    {
      title: 'Your Guide to Credit Repair',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/c69b509469b7f636c167b288e0eaf3c0.webp',
      excerpt:
        'Your credit report can provide you with a detailed picture that can make it easier to spot fraud or errors. Credit repair does not happen overnight, but with these tips, you can take the necessary steps to start fixing it.',
      link: '/credit-repair',
    },
    {
      title: 'The 3 Best Credit Repair Companies in 2024',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/9adc50ba2278621ea18a09a8e12f214f.webp',
      link: '/credit-repair/companies',
    },
    {
      title: 'How Do Credit Repair Services Work?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/05c35cd9f0225b15d092afeff8df910d.webp',
      link: '/credit-repair/services',
    },
    {
      title: '5 Tips To Write Effective Credit Repair Letters',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/8d8d6c9ef045403166a09af7d6a8f9cf.webp',
      link: '/credit-repair/letters',
    },
  ],
  'Mortgage Debt': [
    {
      title: '6 Tips on How To Handle Mortgage Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/7acd7e9df3918cac0ea07a32bcf770c4.webp',
      excerpt:
        'Worrying about mortgage debt is stressful. If you are facing financial hardship, there are options available to manage your situation better and avoid foreclosure.',
      link: '/mortgage-debt',
    },
    {
      title: 'Reverse Mortgage Calculator: How Much Money Can You Get?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/22505248063f3147e959d9b69e602e25.webp',
      link: '/mortgage-debt/reverse-mortgage-calculator',
    },
    {
      title: 'Loan vs. Mortgage: 6 Key Differences',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/a1134402526fe2c01f8970b5db1269fd.webp',
      link: '/mortgage-debt/loan-vs-mortgage',
    },
    {
      title:
        'Mortgage Requirements: Everything You Need to Qualify for a Home Loan',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/c85d3959e8d0faaaea4341d865748318.webp',
      link: '/mortgage-debt/mortgage-requirements',
    },
  ],
  'Divorce Debt': [
    {
      title: 'Your Guide to Divorce Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/c1488b086635716be1860f9aee54bea3.webp',
      excerpt:
        'Divorce comes with a lot of emotional and financial stress. This guide will give you the insight you need to understand how divorce debt is divided and the things you need to consider to reduce the debt burden. ',
      link: '/divorce-debt',
    },
  ],
  'Tax Debt': [
    {
      title: 'What Is Tax Debt and How To Pay it Off',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/3c11c1ca7f2cfb4c4629cf651ecf71bc.webp',
      excerpt:
        'Tax debt can become a heavy financial burden when ignored or missed unintentionally. Sometimes you, as a taxpayer, are unaware of the actual tax liability, or perhaps you are facing financial hardships and can’t keep up with tax commitments.',
      link: '/tax-debt',
    },
    {
      title: 'How Much Are Bonuses Taxed: A Simple Guide',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/ce48fff394ba0bef428abee667388a71.webp',
      link: '/tax-debt/bonus',
    },
    {
      title: 'Can You Go to Jail for Not Paying Taxes?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/9b47b86074c53ec6b0f2d723473ee3f6.webp',
      link: '/tax-debt/can-you-go-to-jail-for-not-paying-taxes',
    },
    {
      title: 'Tax Settlement: A Comprehensive Guide for Financial Relief',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/28eea198e35619deba30381a393c6dc2.webp',
      link: '/tax-debt/settlement',
    },
  ],
  'Gambling Debt': [
    {
      title: 'A Guide To Getting Out Of Gambling Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/252efdf6bee10610eb844b14c0bac49b.webp',
      excerpt:
        'The gambling industry in the U.S. generated a revenue of $54.9 billion in 2022, and almost 85% of Americans have gambled at some point in their life. ',
      link: '/gambling-debt',
    },
  ],
  'Financial Hardship': [
    {
      title: 'How To Deal With Financial Hardship',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/1ffd57d89676acc3ce00f90b8b50b7a4.webp',
      excerpt:
        'The way to financial health is a long journey with many challenges along the way. A global pandemic, sudden emergency, medical expenses, or unemployment can quickly push you into financial hardship.',
      link: '/financial-hardship',
    },
    {
      title: 'Debt Forbearance: Pros and Cons',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/b159873e762c5f815053d6611f915d15.webp',
      link: '/financial-hardship/debt-forbearance',
    },
  ],
  'Credit Counseling': [
    {
      title: '6 Ways Credit Counseling Can Help You',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/c3da1dc52bc2c3fa3c87e2f49db90ed2.webp',
      excerpt:
        'If you are struggling to pay off debt and need a plan to reach your goals, credit counseling can provide you with services and guidance to help you get back on track.',
      link: '/credit-counseling',
    },
  ],
  'Financial Stress': [
    {
      title: '6 Tips to Deal With Financial Stress',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/58b8c39f81a48ec7ddba983500dd338e.webp',
      excerpt:
        'Financial stress is a state of emotional tension, anxiety, or worry, specifically about money. Your stress may stem from your expenses, debt, or income.',
      link: '/financial-stress',
    },
    {
      title: 'Need Help To Pay Your Bills?  6 Ways to Get Financial Assistance',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/d85e2eb7e6635613097f1de59e681c2e.webp',
      link: '/financial-stress/bills',
    },
    {
      title: 'Your Guide to Dealing With Debt Stress',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/5e4e2fed9c53a53863ec1079b1f465bf.webp',
      link: '/financial-stress/debt',
    },
  ],
  Loans: [
    {
      title: 'Loans: Everything You Need to Know',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/56a5655b541b1fd93c110b3f9c160b55.webp',
      excerpt:
        "It's always ideal to save money before you make any large purchases. But that isn’t always possible, especially for expenses such as a home, car, or school. Loans can help you manage these unexpected or large purchases.",
      link: '/loans',
    },
    {
      title: 'APY Vs. Interest Rate: Understanding the Differences',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/227f98339af543ef79fd1178204bcc28.webp',
      link: '/loans/apy-vs-interest-rate',
    },
    {
      title: 'Are Debt Consolidation Loans a Good Idea?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/c709f08b71595e1370bee7bc28d29837.webp',
      link: '/loans/are-debt-consolidation-loans-a-good-idea',
    },
    {
      title: 'FHA Vs. Conventional Loan: 8 Important Differences to Consider',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/06f8b715eadbaf08ab8b4dc70db0f1e9.webp',
      link: '/loans/fha',
    },
  ],
  Bankruptcy: [
    {
      title: 'Is Bankruptcy Right for You? Everything You Need to Know in 2024',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/0efdfbbd3d539394b4d1aaa246157087.webp',
      excerpt:
        'Bankruptcy is a powerful tool that can help you discharge most unsecured debts, but you’ll still be responsible for tax debts, alimony, and child support.',
      link: '/bankruptcy',
    },
    {
      title: 'Chapter 7 Bankruptcy: Pros and Cons and What Happens After',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/d2c7321b583541b3122f8f6c6f42fc0a.webp',
      link: '/bankruptcy/chapter-7',
    },
    {
      title: 'Chapter 13 Bankruptcy: How Does it Work?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/e804495f199633e6777bea9bbecc7692.webp',
      link: '/bankruptcy/chapter-13',
    },
    {
      title: 'Life After Bankruptcy: What You Can and Can’t Do',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/143c7b2667d2bea3d12b257ce16a4e3c.webp',
      link: '/bankruptcy/limitations-after-filing',
    },
  ],
  'Business Debt': [
    {
      title: 'Effective Strategies to Get Relief from Business Debt',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/aae7cdcd0bbaa8f24541c207d990246f.webp',
      excerpt:
        'When used poorly, business debt can cause irreparable harm to your business. Understanding the difference between good and bad business debt is crucial so you can learn how to use it for your benefit. Learn more about the options available for dealing with business debt.',
      link: '/business-debt',
    },
    {
      title: 'DSCR Loan: A Guide for Property Borrowers',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/1a1898419a8ec7adcaccf65269317482.webp',
      link: '/business-debt/dscr',
    },
    {
      title: '14 Types of Business Loans To Help Your Company Grow',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/959bc38a36d1ceb3231bfae499ba8e21.webp',
      link: '/business-debt/loans',
    },
    {
      title: 'What Is a Commercial and Industrial (C&I) Loan?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/bd6391007578567c88f154bba5701433.webp',
      link: '/business-debt/c-and-i-loan',
    },
  ],
  'Areas We Serve': [
    {
      title: 'Find Debt Relief Near You ',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/d372c6a1c0129b4140cced4b9d0c240e.webp',
      excerpt:
        'Finding trusted debt relief near you is easy. TurboDebt is a certified debt relief agency serving nearly every state and U.S. territory. With over 8,000 five-star reviews across Trustpilot and Google, TurboDebt is a trusted source for debt relief in the U.S.',
      link: '/areas-we-serve',
    },
    {
      title: 'California Debt Relief: What to Know',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/50093d21e6e6af73243fc4303c1bb11c.webp',
      link: '/areas-we-serve/california-debt-relief',
    },
    {
      title: 'Illinois Debt Relief',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/0a5f5729775b95719bee7f26c90a6c35.webp',
      link: '/areas-we-serve/illinois-debt-relief',
    },
    {
      title: 'Florida Debt Relief',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/6669db7b3c9e6c5d009c384ef1d9c82d.webp',
      link: '/areas-we-serve/florida-debt-relief',
    },
  ],
  'Senior Debt': [
    {
      title: 'Resources for Senior Citizens',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/528ff7fa74365e6648237af864ba7e1d.webp',
      excerpt:
        'Social Security benefits may be the only income source for many older adults in America. Managing health expenses, groceries, housing, and other basic needs amidst a prolonged stretch of high inflation can be challenging for those without retirement savings.',
      link: '/senior-citizen',
    },
    {
      title: 'Grocery Stimulus for Seniors: What’s Really Available in 2024?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/f431e6c27ac266651a1c941c826b9f6b.webp',
      link: '/senior-citizen/assistance/grocery-stimulus',
    },
    {
      title: 'Debt Relief for Senior Citizens: All the Options Available',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/de6ccdebfb90c66f369a266b92143c9d.webp',
      link: '/senior-citizen/debt-relief',
    },
    {
      title: 'Senior Citizens: 5 Options To Pay Off Your Debts',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/0ec9496544a9394c9316945cdcf2d41c.webp',
      link: '/senior-citizen/assistance',
    },
  ],
  'Car Debt': [
    {
      title: 'Car Debt: 9 Solutions To Pay Off Your Debt ',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/7a70db70944378405e8ee7dc02e50667.webp',
      excerpt:
        'With the overall U.S. car debt growing, you may find yourself having problems keeping up with debt repayment. Know that there are many options available to ease the burden, such as refinancing, budgeting, and paying off your other debts.',
      link: '/car-debt',
    },
    {
      title: 'How Do Car Loans Work: A Useful Guide',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/65f87a2a6883034f587d77c8fefe9347.webp',
      link: '/car-debt/loan',
    },
    {
      title: 'How Does Leasing a Car Work: A Simple Guide',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/cd03fc63fd5f26c234c5f2ab05dc4163.webp',
      link: '/car-debt/lease',
    },
    {
      title: 'Leasing vs Buying a Car: What’s the Best Option?',
      image:
        'https://td-site-storage.sfo3.cdn.digitaloceanspaces.com/posts/9c6d45604ad8b74f8304d790f60ceebf.webp',
      link: '/car-debt/lease-vs-buy',
    },
  ],
}

/**
 * @param {{ image: string, title: string, link: string, excerpt?: string }} article
 * @param {boolean} isSingle
 * @returns {string}
 */
export function articleTemplate(article, isSingle = false) {
  return `
    <div class="debt-management-article ${isSingle ? 'debt-management-article--single' : ''}">
      <img
        class="debt-management-article-image"
        src="${article.image}"
        loading="lazy"
        alt=""
        width="80"
        height="53"
      />
      <div class="debt-management-article-container">
        <a
          href="https://www.turbodebt.com${article.link}"
        >
          ${article.title}
        </a>
        <div class="debt-management-article-excerpt hidden">
          ${article.excerpt ? article.excerpt : ''}
        </div>
      </div>
    </div>
  `
}
